import apiClient from './client'
import type { ApiResponse } from './types'

export interface ChecklistItem {
  code: string
  category: string
  priority: 1 | 2 | 3
  seq: number
  title: string
  description: string | null
  autoMatched: boolean
}

export interface UserChecklist {
  answers: Record<string, number>
  answeredCount: number
  completedAt: string | null
  targetFacilityIds: number[]
}

export interface FacilityScore {
  facilityId: number
  itemResults: Record<string, 'PASS' | 'FAIL' | 'UNKNOWN'>
  passCount: number
  autoMatchCount: number
}

export interface FacilityRecommendation {
  facilityId: number
  name: string
  facilityType: string | null
  addressSido: string | null
  addressSigungu: string | null
  evaluationGrade: string | null
  thumbnailUrl: string | null
  score: number
  passCount: number
  autoMatchCount: number
  distanceKm: number | null
}

export async function fetchChecklistItems(): Promise<ChecklistItem[]> {
  const res = await apiClient.get<ApiResponse<ChecklistItem[]>>('/checklist/items')
  return res.data.data
}

export async function fetchMyChecklist(): Promise<UserChecklist> {
  const res = await apiClient.get<ApiResponse<UserChecklist>>('/checklist/me')
  return res.data.data
}

export async function saveMyChecklist(
  answers: Record<string, number>,
  targetFacilityIds?: number[]
): Promise<UserChecklist> {
  const res = await apiClient.post<ApiResponse<UserChecklist>>('/checklist/me', {
    answers,
    targetFacilityIds,
  })
  return res.data.data
}

export async function completeMyChecklist(): Promise<UserChecklist> {
  const res = await apiClient.post<ApiResponse<UserChecklist>>('/checklist/me/complete')
  return res.data.data
}

export async function fetchFacilityScore(facilityId: number): Promise<FacilityScore> {
  const res = await apiClient.get<ApiResponse<FacilityScore>>(
    `/checklist/facilities/${facilityId}/score`
  )
  return res.data.data
}

export async function fetchRecommendations(
  answers: Record<string, number>,
  options?: {
    sido?: string
    limit?: number
    userLat?: number
    userLng?: number
  }
): Promise<FacilityRecommendation[]> {
  const res = await apiClient.post<ApiResponse<FacilityRecommendation[]>>(
    '/checklist/recommendations',
    {
      answers,
      sido: options?.sido,
      limit: options?.limit,
      userLat: options?.userLat,
      userLng: options?.userLng,
    }
  )
  return res.data.data
}
